import React, { useEffect, useState } from 'react';
import { toast } from 'react-hot-toast';
import { dependentsServices } from '../../../../api/services/dependentsServices';
import DownloadDocController from '../../../../domain/myProfile/documents/DownloadDocs/DownloadDocController';
import { setAlldependentslist } from '../../../../infra/aggregates/myProfile/DependentsAggregates/dependentslistSlice';
import { useAppDispatch, useAppSelector } from '../../../../infra/hooks';
import DepInsurancePresenter from './DepInsurancePresenter';
interface ModalInterface {
  isModalOpen: boolean;
  closeModal: any;
  insuranceList: any;
  trans?: any;
}
const DepInsuranceController = ({
  isModalOpen,
  closeModal,
  insuranceList,
  trans,
}: ModalInterface) => {
  const selector = useAppSelector((state) => state.authSlice);
  const empId: any = selector.emp_id;
  const [attachmentUrl, setAttachmentUrl] = useState('');
  const [open_modal, setOpenModal] = useState(false);
  const dispatch = useAppDispatch();
  const full_path = '';
  const getAttchedDocs = async (id: number) => {
    await dependentsServices
      .getInsuranceAttachedDoc(id, full_path)
      .then((response) => {
        if (response.response == 'success') {
          const url = response.data.attachment;
          if (url != '') {
            setAttachmentUrl(url);
            setOpenModal(true);
          } else {
            toast.error(trans('There is no Attachments!'));
          }
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };
  const getDocsIdItemToBeDeleted = async (id: number) => {
    const response: any = await dependentsServices.deleteInsuranceDocs(
      id,
      empId,
    );
    if (response.response == 'success') {
      dispatch(setAlldependentslist(response.data));
      toast.success(trans('Deleted Successfully'));
      closeModal(false);
    }
  };
  return (
    <>
      <DepInsurancePresenter
        setDocsIdFordeletion={getDocsIdItemToBeDeleted}
        isModalOpen={isModalOpen}
        closeModal={closeModal}
        insuranceList={insuranceList}
        setExpiryInsuranceAttachedDoc={getAttchedDocs}
        trans={trans}
      />
      {open_modal && (
        <DownloadDocController
          isModalOpen={open_modal}
          closeModal={() => setOpenModal(false)}
          attachmentUrl={attachmentUrl}
        />
      )}
    </>
  );
};
export default DepInsuranceController;
